// extracted by mini-css-extract-plugin
export var alignBottom = "no-image-module--alignBottom--a6fbf";
export var alignCenter = "no-image-module--alignCenter--2c9d3";
export var alignTop = "no-image-module--alignTop--929f8";
export var contentContainer = "no-image-module--contentContainer--0a036";
export var ctaContainer = "no-image-module--ctaContainer--d597d";
export var justifyCenter = "no-image-module--justifyCenter--02665";
export var justifyLeft = "no-image-module--justifyLeft--4acae";
export var justifyRight = "no-image-module--justifyRight--b8b89";
export var moduleContainer = "no-image-module--moduleContainer--e27dc";